import React from 'react';
import { Card } from './ui/Card';
import { Briefcase, StickyNote } from 'lucide-react';
import { ScoreRing } from './ui/ScoreRing';
interface DealPossibilitiesCardProps {
  highlighted?: boolean;
}
const transactionDetails = [{
  label: 'Home Value (Est.)',
  value: '$900,000'
}, {
  label: 'Current Mortgage',
  value: '$400,000'
}, {
  label: 'Available Equity',
  value: '$500,000',
  sub: '55.6% equity'
}, {
  label: 'Credit Score',
  value: '760',
  badge: 'Excellent',
  badgeColor: 'text-green-600 bg-green-50'
}, {
  label: 'Current Rate',
  value: '3.25%'
}, {
  label: 'Purpose',
  value: 'Son needs financial help'
}, {
  label: 'Client Preference',
  value: 'HELOC with interest-only'
}, {
  label: 'Debt-to-Income',
  value: '28%',
  badge: 'Good',
  badgeColor: 'text-green-600 bg-green-50'
}];
export function DealPossibilitiesCard({
  highlighted
}: DealPossibilitiesCardProps) {
  return <Card delay={0.2} className="flex flex-col" highlighted={highlighted} data-id="element-109">
      <div className="flex items-center justify-between mb-6" data-id="element-110">
        <h2 className="text-2xl text-navy flex items-center gap-2" data-id="element-111">
          <Briefcase className="text-crimson" size={24} data-id="element-112" />
          Deal Possibilities
        </h2>
        <ScoreRing score={9} size="sm" dynamicColor data-id="element-113" />
      </div>

      {/* Score Reason */}
      <div className="mb-6" data-id="element-114">
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-115">
          Score Reason
        </h3>
        <p className="text-sm text-gray-700 leading-relaxed mb-3" data-id="element-116">
          The client is interested in taking cash out and has a clear purpose
          for the funds. The agent provided suitable options, and the client was
          receptive to the HELOC option. The client's good credit score and low
          first mortgage rate further enhance the likelihood of deal closure.
        </p>
        <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1 marker:text-crimson" data-id="element-117">
          <li data-id="element-118">HELOC with up to 90% LTV</li>
          <li data-id="element-119">Cash-out refinance with up to 80% LTV</li>
        </ul>
      </div>

      {/* Transaction Details */}
      <div className="border-t border-warmgray pt-5 mb-6" data-id="element-120">
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4" data-id="element-121">
          Transaction Details
        </h3>
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4" data-id="element-122">
          {transactionDetails.map(item => <div key={item.label} data-id="element-123">
              <dt className="text-xs font-medium text-gray-500" data-id="element-124">
                {item.label}
              </dt>
              <dd className="mt-0.5 text-sm font-medium text-gray-900 flex items-center gap-2" data-id="element-125">
                {item.value}
                {item.sub && <span className="text-xs text-gray-500 font-normal" data-id="element-126">
                    ({item.sub})
                  </span>}
                {item.badge && <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${item.badgeColor}`} data-id="element-127">
                    {item.badge}
                  </span>}
              </dd>
            </div>)}
        </dl>
      </div>

      {/* Client Notes */}
      <div className="border-t border-warmgray pt-5" data-id="element-128">
        <div className="flex items-start gap-2" data-id="element-129">
          <StickyNote size={16} className="text-gray-400 mt-0.5 shrink-0" data-id="element-130" />
          <div data-id="element-131">
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1" data-id="element-132">
              Client Notes
            </h3>
            <p className="text-sm text-gray-600 italic leading-relaxed" data-id="element-133">
              Client mentioned son is starting a business and needs $150K.
              Prefers to keep monthly payments low — interest-only is important
              to them.
            </p>
          </div>
        </div>
      </div>
    </Card>;
}